export default "__VITE_ASSET__C1IrCV4e__"